import { LICENSED_PRODUCTS } from '@atlassian/jira-common-util-get-tenant-context/src/index.tsx';
import businessImageUrl from './assets/briefcase.svg';
import softwareImageUrl from './assets/jira-laptop-done.svg';
import serviceDeskImageUrl from './assets/service-bell-window.svg';
import messages from './messages.tsx';

const { JIRA_SOFTWARE, JIRA_SERVICEDESK, JIRA_CORE, JIRA_PRODUCT_DISCOVERY } = LICENSED_PRODUCTS;

export const getProjectTypeInfo = (projectType: undefined | string) => {
	switch (projectType) {
		case 'software':
			return {
				projectType,
				product: JIRA_SOFTWARE,
				heading: messages.jiraSoftwareHeading,
				description: messages.jiraSoftwareDescription,
				imageUrl: softwareImageUrl,
				recommendedTemplate: undefined,
				defaultSelectedTemplateKey: undefined,
			};
		case 'service_desk':
			return {
				projectType,
				product: JIRA_SERVICEDESK,
				heading: messages.jiraServiceManagementHeading,
				description: messages.jiraServiceManagementDescription,
				imageUrl: serviceDeskImageUrl,
				recommendedTemplate: undefined,
				defaultSelectedTemplateKey: undefined,
			};
		case 'business':
			return {
				projectType,
				product: JIRA_CORE,
				heading: messages.jiraCoreHeading,
				description: messages.jiraCoreDescription,
				imageUrl: businessImageUrl,
				recommendedTemplate: {
					templateKey:
						'com.atlassian.jira-core-project-templates:jira-core-simplified-project-management',
					isSimplified: false,
				},
				defaultSelectedTemplateKey: undefined,
			};
		case 'product_discovery':
			return {
				projectType,
				product: JIRA_PRODUCT_DISCOVERY,
				heading: messages.jiraProductDiscoveryHeading,
				description: messages.jiraProductDiscoveryDescription,
				imageUrl: softwareImageUrl, // TODO: follow up https://pi-dev-sandbox.atlassian.net/browse/POL-1804
				recommendedTemplate: {
					templateKey: 'jira.polaris:discovery',
					isSimplified: false,
				},
				defaultSelectedTemplateKey: 'jira.polaris:discovery',
			};
		default:
			return {};
	}
};
